module.exports = __webpack_public_path__ + "img/programs_default.b5f79fb1.png";